import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center"
    },
    switchContainer: {
      height: "45px",
      padding: "10px"
    },
    switchContainerAbsolute: {
      position: "absolute",
      width: "160px",
      padding: "10px",
      zIndex: 100
    }
  })
);
